import { combineReducers } from 'redux';
import info from './info';

export default combineReducers({
  info,
});
